'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildChatHeadingConfig = undefined;

var _getType = require('../operators/getType');

var _buildChatHeadingConfigFromType = require('./buildChatHeadingConfigFromType');

var buildChatHeadingConfig = exports.buildChatHeadingConfig = function buildChatHeadingConfig(options) {
  var chatConfigType = (0, _getType.getType)(options);
  return (0, _buildChatHeadingConfigFromType.buildChatHeadingConfigFromType)(chatConfigType, options);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/builders/buildChatHeadingConfig.js
// module id = 455
// module chunks = 2 3